import { logActivity, ACTIVITY_TYPES, RESOURCE_TYPES } from '../../utils/activityLogger';

/**
 * Activity log entries for recording and pitch grading (desktop). They get
 * action types of their own, rather than the generic practice_control, so
 * the activity log shows them by name and can filter on them; the
 * description says what happened in words, the metadata the details.
 */

const log = (actionType) => ({ user, fileName, description, metadata = {} }) => logActivity({
  user,
  actionType,
  resourceType: RESOURCE_TYPES.MUSICXML,
  resourceId: fileName || null,
  description,
  metadata: { ui: 'desktop_shell', ...metadata }
});

export const logRecording = log(ACTIVITY_TYPES.RECORDING);
export const logGrading = log(ACTIVITY_TYPES.PITCH_GRADING);

/** "bars 9–12" (or "bar 9") for the selected bars, or null if none. */
export const barsOf = (range) => {
  if (!range || range.start === null || range.start === undefined) return null;
  const end = range.end === null || range.end === undefined ? range.start : range.end;
  return end === range.start ? `bar ${range.start}` : `bars ${range.start}–${end}`;
};

/** "1 min 05 s", "42 s" */
export const spoken = (seconds) => {
  const s = Math.max(0, Math.round(seconds));
  return s >= 60 ? `${Math.floor(s / 60)} min ${String(s % 60).padStart(2, '0')} s` : `${s} s`;
};
